var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPersoninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.796,
    height: 19.595
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 1196",
    d: "M8.398 8.452a4.226 4.226 0 10-4.172-4.226 4.2 4.2 0 004.172 4.226zm0-7.044a2.818 2.818 0 11-2.781 2.817 2.8 2.8 0 012.781-2.817z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 1197",
    d: "M9.8 9.03H7a7.029 7.029 0 00-7 7.044v1.409a2.109 2.109 0 002.1 2.113h12.6a2.109 2.109 0 002.1-2.113v-1.409a7.029 7.029 0 00-7-7.044zm5.6 8.452a.7.7 0 01-.7.7h-1.4v-2.108a.7.7 0 10-1.4 0v2.113h-7v-2.113a.7.7 0 10-1.4 0v2.113H2.1a.7.7 0 01-.7-.7v-1.413A5.623 5.623 0 017 10.439h2.8a5.623 5.623 0 015.6 5.635z"
  }))));
}

export default SvgPersoninline;